import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";

const AppConfigContext = createContext(null);

const defaultConfig = {
    appName: "kompas.racing",
    version: "dev",
};

export const AppConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(defaultConfig);

    const loadConfig = useCallback(async () => {
        try {
            const response = await fetch("/api/config/");
            if (!response.ok) {
                return;
            }
            const data = await response.json();
            setConfig({
                appName: data.app_name || defaultConfig.appName,
                version: data.version || defaultConfig.version,
            });
        } catch (_error) {
            return;
        }
    }, []);

    useEffect(() => {
        loadConfig();
    }, [loadConfig]);

    const value = useMemo(
        () => ({
            ...config,
            reload: loadConfig,
        }),
        [config, loadConfig]
    );

    return (
        <AppConfigContext.Provider value={value}>
            {children}
        </AppConfigContext.Provider>
    );
};

export const useAppConfig = () => {
    const context = useContext(AppConfigContext);
    if (!context) {
        return { ...defaultConfig, reload: () => {} };
    }
    return context;
};
